import { render, staticRenderFns } from "./NotificationPostSidebar.vue?vue&type=template&id=13735cf0"
import script from "./NotificationPostSidebar.vue?vue&type=script&lang=js"
export * from "./NotificationPostSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports